// 像素美术调色板：canvas 逐像素绘制用色，与主题无关，保留
/* 像素办公室 · 形象持久化（仅存 localStorage，不调任何后端）
 * localStorage 键：pixel_avatar -> { skin, hair, shirt, name }
 * 配色从原型暖色系中挑选的协调组合：3 肤色 × 4 发色 × 5 衣服色
 */

const KEY = 'pixel_avatar';

export const SKIN_OPTIONS = [
  { id: 'porcelain', label: '米白', main: '#f2c894', dark: '#e0b07e' },
  { id: 'wheat', label: '小麦', main: '#e8b184', dark: '#d69a6a' },
  { id: 'tan', label: '深麦', main: '#cf9a68', dark: '#b8825a' },
];

export const HAIR_OPTIONS = [
  { id: 'chestnut', label: '栗棕', main: '#4a3728', light: '#6b4f3a' },
  { id: 'ink', label: '墨黑', main: '#2f2b33', light: '#4c4652' },
  { id: 'amber', label: '暖橘', main: '#b96a3a', light: '#d98e55' },
  { id: 'plum', label: '莓紫', main: '#6e4a5a', light: '#8f6678' },
];

export const SHIRT_OPTIONS = [
  { id: 'coral', label: '珊瑚橙', main: '#f4a261', dark: '#e08a45' },
  { id: 'gold', label: '暖金', main: '#e9c46a', dark: '#d4a744' },
  { id: 'mint', label: '薄荷', main: '#a8dadc', dark: '#8bc4c2' },
  { id: 'lavender', label: '薰衣草', main: '#cdb4db', dark: '#b79fc9' },
  { id: 'peach', label: '蜜桃', main: '#ffd6a5', dark: '#eeb98a' },
];

/** 读取已保存形象；没有或损坏时返回 null */
export function loadAvatar() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return null;
    if (typeof data.skin !== 'string' || typeof data.hair !== 'string'
      || typeof data.shirt !== 'string' || typeof data.name !== 'string') return null;
    return { skin: data.skin, hair: data.hair, shirt: data.shirt, name: data.name };
  } catch {
    return null;
  }
}

/** 保存形象（仅 localStorage） */
export function saveAvatar(avatar) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      skin: avatar.skin,
      hair: avatar.hair,
      shirt: avatar.shirt,
      name: avatar.name,
    }));
  } catch { /* localStorage 不可用时静默 */ }
}

/** 默认形象：名字默认取当前用户名 */
export function makeDefaultAvatar(name) {
  return {
    skin: SKIN_OPTIONS[0].id,
    hair: HAIR_OPTIONS[0].id,
    shirt: SHIRT_OPTIONS[0].id,
    name: name || '新同事',
  };
}

/** 把存储的 id 形式解析成引擎可直接取色的颜色对象 */
export function resolveAvatar(avatar) {
  const skin = SKIN_OPTIONS.find((o) => o.id === avatar?.skin) || SKIN_OPTIONS[0];
  const hair = HAIR_OPTIONS.find((o) => o.id === avatar?.hair) || HAIR_OPTIONS[0];
  const shirt = SHIRT_OPTIONS.find((o) => o.id === avatar?.shirt) || SHIRT_OPTIONS[0];
  return {
    name: (avatar?.name || '新同事').slice(0, 12),
    skin: { main: skin.main, dark: skin.dark },
    hair: { main: hair.main, light: hair.light },
    shirt: { main: shirt.main, dark: shirt.dark },
  };
}
